<template>
  <div class="wrapper courses-results-wrapper">
    <div v-if="mode === 'card'" class="results-card-mode-wrapper">
      <div v-for="(classItem, index) in coursesList" :key="index" class="class-card-item-wrapper">
        <ClassCard
          class="class-card-in-list"
          :card-data="classItem"
          :show-wrapper-border="true"
          :show-original-price="true"
          :show-taxation-desc="true"
          :group-buy="classItem.activityItem"
          :show-price-is-include="classItem.showPriceIsInclude===1"
          :show-card-bottom-left="true"
          :total-lessons="classItem.spec.lessonCount"
          :left-lessons="classItem.spec.leftLesson"
          :show-right-top-tag="!classItem.spec.courseClosed"
          :show-back-stamp="true"
          :tag-type="getClassHotTagType(classItem.store, classItem.sellStore, classItem.remainSellTime)"
          :show-per-lesson="classItem.perShowPrice !== undefined"
          :courses-mode="coursesMode"
          :is-courses-list="true"
        />
      </div>
    </div>
    <div v-if="mode === 'list'" class="results-table-mode-wrapper">
      <div v-for="(classItem, index) in coursesList" :key="index" class="class-table-item-wrapper">
        <ClassTable :card-data="classItem" :group-buy="classItem.activityItem" :tag-type="getClassHotTagType(classItem.store, classItem.sellStore, classItem.remainSellTime)" :courses-mode="coursesMode" />
      </div>
    </div>
    <div class="load-more">
      <el-button
        v-if="!loadend"
        plain
        round
        :loading="loading"
        @click="handleLoadMore"
      >
        {{ langContext.loadMoreButtonName }}
      </el-button>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'
import ClassCard from '@/components/web/courses/ClassCard'
import ClassTable from '@/components/web/courses/ClassTable'

export default {
  components: {
    ClassCard,
    ClassTable,
  },
  mixins: [mixin],
  props: {
    coursesMode: {
      type: String,
      default: 'card',
    },
  },
  data() {
    const mode = this.coursesMode
    return {
      mode,
      isInit: true,
    }
  },
  mounted() {
    this.addScrollEvent();
    this.watchScroll();
  },
  methods: {
    // 添加滚动事件
    addScrollEvent() {
      window.addEventListener('scroll', this.watchScroll, false);
    },
    // 移除滚动事件
    removeScrollEvent() {
      window.removeEventListener('scroll', this.watchScroll, false);
    },
    watchScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollTop > 580 && this.isInit) {
        this.isInit = false
        this.handleLoadMore('scroll')
        this.removeScrollEvent()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// 卡片模式
.results-card-mode-wrapper {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .class-card-item-wrapper {
    margin-bottom: 20px;

    &:nth-child(3n + 2) {
      margin-left: 20px;
      margin-right: 20px;
    }
  }

  .class-card-in-list {
    width: 400px;

    /deep/.class-title {
      line-height: 22px;
      height: 44px;
      display: flex;
      align-items: center;
    }
  }
}

// 列表模式
.results-table-mode-wrapper {
  .class-table-item-wrapper {
    margin-bottom: 10px;
  }
}
</style>
